// function for simply Top Sticky elements
(function (Rayban) {
  Rayban.topSticky = function (selector) {
    var header = document.getElementById(selector);
    var sticky = header.offsetTop;

    if (window.pageYOffset > sticky) {
      header.classList.add("sticky");
    } else {
      header.classList.remove("sticky");
    }
  }
})(
  window.Rayban = window.Rayban || {}
);
